module.exports = __webpack_public_path__ + "static/scale-model-of-american-sign-museum-in-cincinnati-ohio-e3ab1509c741801418aedc40963ac0f8.png";